import { useEffect, useState } from "react";
import axios from "axios";
import { ShieldCheck, ShieldAlert } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LIBELLES = { twint: "TWINT", card: "Carte bancaire", klarna: "Klarna" };
const ETATS = { active: ["Actif — proposé au paiement", "text-sage"], pending: ["En attente de validation Stripe", "text-terra"], inactive: ["Disponible mais désactivé — à activer dans Dashboard Stripe → Paramètres → Moyens de paiement", "text-red-700"], indisponible: ["Indisponible sur ce compte (pays / activation Stripe)", "text-fumee"] };

export const AdminStripeEtat = () => {
  const [etat, setEtat] = useState(null);
  const [erreur, setErreur] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/stripe/compte`, { headers: { Authorization: `Bearer ${localStorage.getItem("elm_admin_token") || ""}` }, withCredentials: true })
      .then((r) => setEtat(r.data)).catch((e) => setErreur(e.response?.data?.detail || "Stripe injoignable"));
  }, []);
  if (erreur) return <p className="text-xs text-red-700 mb-6" data-testid="admin-stripe-erreur">{erreur}</p>;
  if (!etat) return null;
  const Icon = etat.charges_actives ? ShieldCheck : ShieldAlert;
  return (
    <div className="bg-card border border-sand-dark rounded-2xl p-5 mb-6 grid sm:grid-cols-[auto_1fr] gap-4 items-start" data-testid="admin-stripe-etat">
      <Icon className={`w-5 h-5 mt-0.5 ${etat.charges_actives ? "text-sage" : "text-terra"}`} />
      <div className="text-sm text-bark">
        <p className="font-serif text-lg">Paiements Stripe — {etat.nom || etat.account_id} <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-fumee ml-2">{etat.livemode ? "mode réel" : "mode test"}</span></p>
        <p className="text-xs text-fumee mt-1">Compte {etat.pays} · {etat.devise?.toUpperCase()} · encaissements {etat.charges_actives ? "actifs" : "inactifs"} · webhook {etat.webhook_configure ? "configuré" : "absent"}</p>
        <ul className="mt-3 flex flex-wrap gap-x-6 gap-y-1" data-testid="admin-stripe-moyens">
          {Object.entries(etat.moyens_paiement || {}).map(([m, v]) => {
            const [label, cls] = ETATS[v] || [v, "text-fumee"];
            return <li key={m} className="text-xs" data-testid={`admin-stripe-moyen-${m}`}><span className="font-mono uppercase tracking-[0.15em] text-bark mr-2">{LIBELLES[m] || m}</span><span className={cls}>{label}</span></li>;
          })}
        </ul>
      </div>
    </div>
  );
};
